import type { CMSSeoContentData } from "@website/website-ui/services/seo-contents/cms-types";
import Faq from "../faq";
import { InboundLinks } from "../inbound-links";
import SeoContent from "../seo-content";

export const SeoComponents = ({ seoData }: { seoData: CMSSeoContentData }) => {
  const { seoContent, FAQ, links } = seoData || {};
  return (
    <>
      {Boolean(seoContent) && <SeoContent html={seoContent} />}
      {Boolean(FAQ?.length) && <Faq list={FAQ} title="پاسخ به برخی سوالات" />}
      {Boolean(links?.length) && (
        <InboundLinks
          linksData={links}
          title="اجاره اقامتگاه در شهرهای پرطرفدار"
        />
      )}
    </>
  );
};
